import { signInHref } from "@nexxt/account-ui";
import { atelierClient } from "@nexxt/api-client/atelier";
import { createQueryClient, liveCapture } from "@nexxt/app-kit";
import type { QueryClient } from "@tanstack/react-query";

let signingIn = false;

/** No session, or it expired or was revoked: the sign-in page, then back to the same page. */
function signIn(): void {
  if (signingIn) return;
  signingIn = true;
  // a full load: nothing of the previous user stays in memory
  location.assign(signInHref(`${location.pathname}${location.search}`));
}

/** The client of the signed-in pages: a 401 is a session that ended. */
export const { api, auth } = atelierClient({ ...liveCapture, onUnauthenticated: signIn });

/**
 * The client of the sign-in pages (password, second step, passkey, link): a 401 there is a refused credential, answered
 * on the page, not a session that ended.
 */
export const { auth: signInAuth } = atelierClient();

export const queryClient: QueryClient = createQueryClient();
